const gamesUrl = '/game';

export default gamesUrl;
